import {Pipe, PipeTransform} from "@angular/core";
import {SimScenarioService, SimUserService} from "@services";
import {from, Observable} from "rxjs";
import {Scenario, SimUser} from "@models";

@Pipe({
	name: "getUserById",
	standalone: false,
})
export class GetUserByIdPipe implements PipeTransform {
	constructor(private _simUserService: SimUserService) {}

	transform(value: string, ...args: unknown[]): Observable<SimUser> {
		return from(this._simUserService.getUserById(value));
	}
}
